<template>
  <div class="total" :class="{'white-theme': whiteTheme}" v-show="totalData !== 0">
    <span class="total-num">{{ totalNum }}</span>
    <span>{{ type }} In Total</span>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },

  props: {
    totalData: {
      type: Number,
      default: 0
    },

    type: {
      type: String,
      default: 'Orders'
    },

    showData: {
      type: Number,
      default: 0
    },

    flag: {
      type: Boolean,
      default: false
    },

    whiteTheme: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    format_number: function (nStr) {
      const x = nStr.toString().split('.');
      let x1 = x[0];
      const x2 = x.length > 1 ? '.' + x[1] : '';
      const rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
      }
      return x1 + x2;
    }
  },

  computed: {
    totalNum() {
      if (this.flag) {
        return (
          this.format_number(this.showData) +
          '/' +
          this.format_number(this.totalData)
        );
      }
      return this.format_number(this.totalData);
    }
  }
};
</script>
<style lang="scss" scoped>
.total {
  text-align: right;
  margin-right: 90px;
}

.total-num {
  color: #fff;
  margin-right: 10px;
}

.white-theme {
  color: #fff;
}
</style>